"use client";

import { Snowflake, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Upgrade() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const services = ["Network Infrastructure", "Video Surveillance", "Access Control", "VoIP Systems"];
  const snowflakes = Array.from({
    length: 24
  }, (_, i) => ({
    id: i,
    left: i * 4.3 % 100,
    delay: i * 0.7 % 12,
    duration: 12 + i * 1.3 % 10,
    size: 4 + i * 1.1 % 6,
    opacity: 0.3 + i * 0.07 % 0.5
  }));
  return <section data-section-id="259" id="ready-to-upgrade" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32 px-4 md:px-8">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715292/img/server_infrastructure_data_center.png)]" />
      <div className="absolute inset-0 bg-background/80" />
      <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/60 to-background/90" />

      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        {snowflakes.map((flake, i) => <span key={flake.id} data-index={i} className="absolute block rounded-lg bg-primary/20 animate-[snowfall_linear_infinite]" style={{
        left: `${flake.left}%`,
        top: `-10px`,
        width: `${flake.size}px`,
        height: `${flake.size}px`,
        opacity: flake.opacity,
        animationDuration: `${flake.duration}s`,
        animationDelay: `-${flake.delay}s`
      }} />)}
      </div>

      <style>{`
        @keyframes snowfall {
          0% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(50vh) translateX(20px); }
          100% { transform: translateY(110vh) translateX(-10px); }
        }
      `}</style>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div ref={ref} className={`lg:col-span-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="backdrop-blur-sm bg-card border border-border rounded-lg p-8 md:p-12 lg:p-16 shadow-lg">
            {}
            <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-accent border border-accent-foreground/20">
              <Snowflake className="w-7 h-7 text-primary" strokeWidth={1.5} />
            </div>

            {}
            <p className="font-mono text-xs tracking-widest uppercase text-primary mb-6">
              Unified IT Solutions
            </p>

            {}
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] text-foreground mb-8 tracking-tight">
              Ready to <em className="italic font-medium text-primary">upgrade</em> your business infrastructure?
            </h2>

            {}
            <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed mb-8 max-w-xl">
              Betaquest, LLC specializes in unified IT solutions tailored to your business needs. Our systems integrate seamlessly to improve performance, security, and scalability for the modern enterprise.
            </p>

            {}
            <div className="flex flex-wrap gap-2 mb-10">
              {services.map((service, i) => <span key={service} data-index={i} className="font-mono text-xs tracking-wide px-4 py-2 rounded-md border border-primary/40 text-foreground bg-secondary/50 backdrop-blur-sm">
                  {service}
                </span>)}
            </div>

            {}
            <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-7 h-12 shadow-md">
                <Link to="/SolutionsPage">
                  <Snowflake className="w-4 h-4" strokeWidth={2} />
                  <span className="font-default font-medium">
                    Explore Solutions
                  </span>
                </Link>
              </Button>

              <Link to="/HomePage" className="font-mono text-xs tracking-widest uppercase text-foreground hover:text-primary transition-colors inline-flex items-center gap-2 group">
                Learn About Us
                <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="hidden lg:block lg:col-span-6" aria-hidden="true" />
      </div>
    </section>;
}